import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { trimString } from "../../Utils";
import { LatesBets, TopBets } from "../../Screens/Aviator/AviatorEndpoints";
import SocketHoc from "../../Screens/Aviator/SocketHoc";


const BetSection = (props) => {
  const [selected, setSelected] = useState(1);
  const [selectedNestedTab, setSelectedNestedTab] = useState(0);
  const [AllTopBets, setAllTopBets] = useState([]);
  const [myBets, setMyBets] = useState([]);
  const [current, setCurrent] = useState(1);
  const [isNextAvail, setIsNextAvail] = useState(null);
  const [isPrevavail, setIsPrevAvail] = useState(null);
  const tabs = [
    {
      id: 1,
      title: "All Bets",
    },
    {
      id: 3,
      title: "Top Bets",
    },
    {
      id: 2,
      title: "My Bets",
    },
  ];
  const NestedTabs = [
    {
      id: 3.1,
      title: "today",
    },
    {
      id: 3.2,
      title: "month",
    },
    {
      id: 3.3,
      title: "year",
    },
  ];
  useEffect(() => {
    LatesBets(`?page=${current}&limit=10`)
      .then((res) => {
        if (res.status) {
          setIsNextAvail(res.nextPage);
          setIsPrevAvail(res.prevPage);
          setMyBets(res.bets);
        }
      })
      .catch((err) => console.log(err));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);
  useEffect(() => {
    TopBets(`?type=${NestedTabs[selectedNestedTab].title}`)
      .then((res) => {
        if (res.status) {
          setAllTopBets(res.data);
        }
      })
      .catch((err) => console.log(err));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNestedTab]);
  return (
    <>
      <div className="bg-primary h-full lg:h-full font-cairo rounded-md">
        <div className="py-4">
          <div className="flex justify-center gap-2 w-[65%] m-auto items-center bg-[#141516] rounded-full">
            {tabs.map((i, index) => {
              return (
                  <p
                  key={index}
                    onClick={() => setSelected(i.id)}
                    className={`text-white text-sm p-1 mx-1 w-full cursor-pointer text-center ${
                      i.id === selected ? "radient rounded-full" : ""
                    }`}
                  >
                    {i.title}
                  </p>
              );
            })}
          </div>
          {selected === 3 && (
            <div className="flex justify-center gap-2 w-[80%] mt-8 m-auto items-center bg-[#141516] rounded-full">
              {NestedTabs.map((i, index) => {
                return (
                    <p
                    key={index}
                      onClick={() => setSelectedNestedTab(index)}
                      className={`text-white capitalize text-sm p-1 mx-1 w-full cursor-pointer text-center ${
                        index === selectedNestedTab
                          ? "radient rounded-full"
                          : ""
                      }`}
                    >
                      {i.title}
                    </p>
                );
              })}
            </div>
          )}
        </div>
        <div className="px-8">
          <div className="flex justify-between items-center text-white font-bold">
            <div>
              <p>All Bets</p>
              <p>
                {selected === 1
                  ? props.AllBets?.data?.demoDataArr.length
                  : myBets.length}
              </p>
            </div>
            {selected === 2 && (
              <div className="flex justify-center items-center gap-2">
                <div
                  onClick={() => {
                    if (isPrevavail) {
                      setCurrent(current - 1);
                    }
                  }}
                  className={` ${
                    isPrevavail
                      ? "bg-[#770100]  cursor-pointer"
                      : "bg-[#d35856] cursor-not-allowed"
                  } p-2 rounded-md`}
                >
                  <FaChevronLeft />
                </div>
                <div
                  onClick={() => {
                    if (isNextAvail) {
                      setCurrent(current + 1);
                    }
                  }}
                  className={` ${
                    isNextAvail
                      ? "bg-[#770100]  cursor-pointer"
                      : "bg-[#d35856] cursor-not-allowed"
                  } p-2 rounded-md`}
                >
                  <FaChevronRight />
                </div>
              </div>
            )}
          </div>
          <div className="bg-[#101112] w-full h-[1px] mt-4"></div>
          <div className=" text-white text-xs mt-4 grid grid-cols-3 place-items-center">
            <p>User</p>
            <p>Bet</p>
            <p>Cash out</p>
          </div>
          {(selected === 1 || selected === 2) && (
            <div className="bg-[#101112]  max-h-[65vh] h-screen mb-4 overflow-y-scroll rounded-md mt-4 p-2">
              {(selected === 1
                ? props.AllBets?.data?.demoDataArr
                : myBets
              )?.map((i, index) => {
                return (
                  <div key={index}>
                    <div className="grid cursor-pointer grid-cols-3 place-items-center my-2">
                      <div className="flex  justify-start w-full gap-x-2 items-start">
                        <div className="w-6 h-6 xl:h-6 rounded-full bg-green-600"></div>
                        <p className="text-[#B6BAC0] text-xs">
                          {trimString(i.name ?? "d3***y6")}
                        </p>
                      </div>
                      <div className="flex  justify-center w-1/2 md:w-full  gap-x-2 items-start">
                        <p className="text-[#B6BAC0] text-xs">
                          {i.betAmount ?? 8000}.00
                        </p>
                        {i.hasOwnProperty("multiplyNumber") && (
                          <p className="text-[#12a7ff] text-xs bg-black px-2 py-1 rounded-full">
                            {i.multiplyNumber}x
                          </p>
                        )}
                      </div>
                      <p className="text-[#B6BAC0]  w-full h-full text-center  text-xs">
                        {trimString(i?.winingAmount?.toString() ?? 0)}.00
                      </p>
                    </div>
                    <div className="bg-[#737882] w-full h-[1px] "></div>
                  </div>
                );
              })}
            </div>
          )}
          {selected === 3 && (
            <div className="bg-[#101112] l max-h-[400px] h-screen mb-4 overflow-y-scroll rounded-md mt-4 p-2">
              {AllTopBets?.map((i, index) => {
                return (
                  <div key={index}>
                    <div className="grid cursor-pointer grid-cols-3 place-items-center my-2">
                      <div className="flex justify-start w-full gap-x-2 items-start">
                        <div className="w-6 h-6 xl:h-6 rounded-full bg-green-600"></div>
                        <p className="text-[#B6BAC0] text-xs">
                          {trimString(i?.demoDataArr?.name ?? "d3***y6")}
                        </p>
                      </div>
                      <div className="flex justify-center w-1/2 md:w-full  gap-x-2 items-start">
                        <p className="text-[#B6BAC0] text-xs">
                          {i?.demoDataArr?.betAmount ?? 8000}.00
                        </p>
                        {i.demoDataArr?.hasOwnProperty("multiplyNumber") && (
                          <p className="text-[#12a7ff] text-xs bg-black px-2 py-1 rounded-full">
                            {i?.demoDataArr?.multiplyNumber}x
                          </p>
                        )}
                      </div>
                      <p className="text-[#B6BAC0] w-full text-center  text-xs">
                        {trimString(i?.winingAmount?.toString() ?? 0)}.00
                      </p>
                    </div>
                    <div className="bg-[#737882] w-full h-[1px] "></div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SocketHoc(BetSection);
